'use client';

import { ContactTileTitle } from '@vs-shop/commerce-ui/contactTile';
import { Heading } from '@vs-shop/ui/heading';
import { useIntl } from 'react-intl';

/**
 * The tile's invitation. The element is rcprofi's decision — a level-3 heading,
 * because the tile sits among the product names of a listing that announces
 * those as headings too.
 */
export default function ContactUsProductCardHeading() {
  const intl = useIntl();
  return (
    <ContactTileTitle render={<Heading level={3} hover={false} />}>
      {intl.formatMessage(
        {
          defaultMessage: 'Nenašli jste, co hledáte? {breakLine} Napište nám.',
          id: 'contactUsProductCard.title',
        },
        {
          breakLine: <br key="breakLine" />,
        }
      )}
    </ContactTileTitle>
  );
}
